import {
  ConfigTypes,
  BuilderTypes,
  TitleAlign,
} from "@/api/AppApi/common-interfaces/api-enums";
export enum CategoryStyleTypes {
  circle_icon = "circle_icon", //default
  circle_img = "circle_img",
  square = "square",
  square_primary = "square_primary",
  square_primary_title = "square_primary_title",
}
export interface IProduct_Category_Config_Customize {
  advance_mode: boolean;
  align: string;
  background_color: string;
  font_size: number;
  font_size_tablet_h?: number;
  font_size_tablet_v?: number;
  font_size_mobile_h?: number;
  font_size_mobile: number;
  gap: number;
  gap_tablet_h?: number;
  gap_tablet_v?: number;
  gap_mobile_h?: number;
  gap_mobile: number;
  height: number;
  height_tablet_h?: number;
  height_tablet_v?: number;
  height_mobile_h?: number;
  height_mobile: number;
  interval: number;
  justify: string;
  slide_num: number;
  slide_num_tablet_h?: number;
  slide_num_tablet_v?: number;
  slide_num_mobile_h?: number;
  slide_num_mobile: number;
  width: number;
  width_tablet_h?: number;
  width_tablet_v?: number;
  width_mobile_h?: number;
  width_mobile: number;
  show_price: boolean;
}

export interface IProduct_Scrollable_Tabs_Config_Customize {
  image_position: "start" | "end";
}
export type Config_Customize =
  | IProduct_Category_Config_Customize
  | IProduct_Scrollable_Tabs_Config_Customize;
export interface ICategory {
  icon: string;
  id: number;
  image: string;
  name: string;
  subcategories_count: number;
  slug: string;
}
export interface ICategories {
  index?: number;
  type?: BuilderTypes.category | BuilderTypes.blog_category;
  configurations?: {
    customize?: IProduct_Category_Config_Customize;
    title?: string;
    target_url?: string;
    type: ConfigTypes;
    title_align?: TitleAlign;
    style_type: CategoryStyleTypes;
    // interval?: number; //not in api
    view_all?: boolean;
  };
  data: ICategory[];
}
export interface IBlogCategories {
  index?: number;
  type?: BuilderTypes.blog_category;
  configurations?: {
    customize?: IProduct_Category_Config_Customize;
    title?: string;
    target_url?: string;
    type: ConfigTypes;
    title_align?: TitleAlign;
    style_type: CategoryStyleTypes;
    // interval?: number; //not in api
    view_all?: boolean;
  };
  data: BlogCategoryData[];
}

export interface BlogCategoryData {
  key: string;
  value: string;
  image_url: string;
  blogs_count: number;
}
